import React from 'react';
import { find } from 'lodash';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import Title from '../title';
import Purchase from '../../lib/purchase';
import PurchaseKeyInfo from '../../containers/purchase-key-info.container';
import { Time, TIME_FORMAT_HOUR } from '../../../components/Time';

const PurchaseDetails = ({ payments, dueDeadline }) => (
  <div className="purchase-details container">
    <div className="container">
      <Title
        text={
          <FormattedMessage
            id="purchaseDetails.title"
            defaultMessage="Details"
          />
        }
        name="details"
        className="details-title"
        divider
        bigger
      />
      <div className="mt-4 pb-4">
        <Title
          text={
            <FormattedMessage
              id="purchaseDetails.keyInfo.title"
              defaultMessage="Key Information"
            />
          }
          className="key-info-title"
          bigger
        />
      </div>
      <PurchaseKeyInfo />
      {dueDeadline && renderDueDeadline(payments, dueDeadline)}
    </div>
  </div>
);

const renderDueDeadline = (payments, dueDeadline) => (
  <div className="due-deadline mb-5">
    <p>
      <span className="text-muted">{dueDeadlineCopy(payments)}</span>
      {' '}
      <Time time={dueDeadline} timezone={moment.tz.guess()} />
      {' '}
      <Time format={TIME_FORMAT_HOUR} time={dueDeadline} timezone={moment.tz.guess()} />
    </p>
  </div>
);

const dueDeadlineCopy = (payments) => {
  if (Purchase.isMultiPayment(payments) && hasCapturedPayments(payments)) {
    return (
      <FormattedMessage
        id="purchaseDetails.multiPayment"
        defaultMessage="Group's next payment due by: "
      />
    );
  }

  if (Purchase.isSinglePayment(payments) || !hasCapturedPayments(payments)) {
    return (
      <FormattedMessage
        id="purchaseDetails.dueDeadline.singlePayment"
        defaultMessage="Must purchase by (if inventory still available): "
      />
    );
  }

  return '---';
};

const hasCapturedPayments = (payments) => {
  return !!find(payments, payment => payment.status === 'captured');
};

export default PurchaseDetails;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/purchase-details.js